var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_UserDetailsSection',[_c('UserDetails_Header_Small',[_vm._v(_vm._s(_vm.$t("users.top-ranked-tags")))]),_c('List_Scrollable_HashTags',{staticClass:"my-1",attrs:{"tags":_vm.popular}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }